export enum Scripts {
    LiveChat = 'livechat',
    Adobe = 'adobe',
    Config = 'config',
    CookieBot = 'cookie-bot',
    UpdateBillingSdk = 'update-billing-sdk'
}